import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormCheck } from 'react-bootstrap';
import AreaN2DataService from "./services/arean2.service";
import PosicionDataService from './services/posicion.service';
import OrganigramaDataService from "./services/organigrama.service";
import OrganigramaAreaDataService from './services/organigramaarea.service'
import { useParams, useLocation } from "react-router-dom";
import { useEffect } from 'react';
//import SublocationsList from './AreaN2List';
//import NewSublocation from './NewSublocation';
import { PageHeader } from './AuxiliaryFunctions';
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';
import CompetenciaAreasN2List from './CompetenciaAreasN2List';
import AgregarPosicion from './AgregarPosicion';
import CompetenciaPosicionesList from './CompetenciaPosicionesList';



var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditOrganigramaPosiciones = (props) => {
  

  let params = useParams();
  const location = useLocation();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [listOfPosiciones, setlistOflistOfPosiciones] = useState([]);
  const [arean2, setAreaN2] = useState(null);
  //const {organigrama} = location.state.organigrama || {};
  const [organigrama, setOrganigrama] = useState({});
  const [pagetitle, setpagetitle] = useState(null);

  useEffect(() => {
    retrieveAreaN2();
    retrieveOrganigramaPosiciones();  
    setOrganigrama(location.state?location.state.organigrama:{});    
    if (!organigrama) {
      //window.location.assign("/organigramas");
    }    
  }, []);

  useEffect(() => {
    if (arean2) {
      console.log(retrieveAreaN2);
      setpagetitle("Organigrama: " + organigrama.nombreorganigrama + "; área N2: " + arean2.nombrearea);
    }
    else {
      setpagetitle("No existe el área N2 con id=" + params.childid);      
    }
  }, [arean2]);

  const retrieveAreaN2 = () => {
    AreaN2DataService.get(params.childid)
      .then(response => {
        console.log(response.data);
        setAreaN2(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }  

  const retrieveOrganigramaPosiciones = () => {
    OrganigramaAreaDataService.getOrganigramaArea({parentid:params.idorganigramaarea, childid:0, childcategory:'posicion'},"id","ASC")
      .then(response => {
        setlistOflistOfPosiciones(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }
  
  return (
    <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />            
        <Container>
          <Row className='mb-4'>
            <PageHeader />
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{pagetitle}</h5>      
          
            {showerror && (
              <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                <Alert.Heading>Error</Alert.Heading>
                <p>{errmessage}</p>
              </Alert>      
            )}
            {showsuccess && (
              <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                <Alert.Heading>Done</Alert.Heading>
                <p>{succmessage}</p>
            </Alert>      
            )}   
          </Row>

          <Row className='mb-4'>  
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre organigrama:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombreorganigrama" id="nombreorganigrama" disabled defaultValue={organigrama?organigrama.nombreorganigrama:null}></FormControl>
            </Col>             

            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre área N2:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean2" id="nombrearean2" disabled defaultValue={arean2?arean2.nombrearea:null}></FormControl>
            </Col>             
            <Col md={10}>
              <FormLabel className='mb-2'>Descripción área N2:</FormLabel>       
              <FormControl type="text" name="descripcionarean2" id="descripcionarean2" disabled defaultValue={arean2?arean2.descripcionarea:null}></FormControl>
            </Col> 
            <Col className='col-md-3' md={4}>
              {/*<Button variant='secondary'> Agregar área N1</Button>*/}
              <AgregarPosicion arean2={arean2} parentid={params.idorganigramaarea}/> 
            </Col>                                         
            
          </Row>
        
          <Row className='mb-4'>
              <Alert>{"Posiciones habilitadas para este organigrama. Utilice el botón (+) para agregar más posiciones."}</Alert>
              <CompetenciaPosicionesList 
                mode={0} 
                listOfPosiciones={listOfPosiciones}
              >
              </CompetenciaPosicionesList>            
          </Row>                                     
        </Container>    
      </div>
    </>
  )

}

export default EditOrganigramaPosiciones;

